import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Container from "./Container";
import FindProgrammingContainer from "./FindProgrammingContainer";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar'
import FindInPageIcon from '@material-ui/icons/FindInPage'
import ImageIcon from '@material-ui/icons/Image'
import SettingIcon from '@material-ui/icons/Settings';
import * as _ from 'lodash'
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled'
import { Link, Route, Switch, withRouter } from "react-router-dom";
import { bffUrl } from '../src/config'
import axios from "axios";
import clsx from 'clsx';
import AssessmentIcon from '@material-ui/icons/Assessment'
import AssignmentIcon from '@material-ui/icons/Assignment';
import InputIcon from '@material-ui/icons/Input'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import WebAssetIcon from '@material-ui/icons/WebAsset';
import CollectionsIcon from '@material-ui/icons/Collections';
import ReactGA from 'react-ga';

import AccountCircle from '@material-ui/icons/AccountCircle';
import VideoAnalyzerContainer from "./VideoAnalyzerContainer";
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import firebaseapp from './firebaseapp.js';

import * as firebaseui from 'firebaseui'

import fireBaseLib from 'firebase/app'
import 'firebaseui/dist/firebaseui.css'
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ConfigContainer from "./ConfigContainer";
import VersionInfo from "./VersionInfo";

import { connect } from 'react-redux';
import { fetchPrivileges, fetchPrivilegesWithRegions } from './actions/privilegeActions'
import ThumbnailPrint from './ThumbnailPrint';
import TranscodingStatusContainer from './TranscodingStatusContainer';
import IngestionHelperContainer from "./IngestionHelperContainer";
import TranscodingHelperContainer from "./TranscodingHelperContainer";
import TranscodingTriggerTool from './TranscodingTriggerTool'
import SimulcastHelperContainer from "./SimulcastHelperContainer";
import DRMPlayerContainer from "./DRMPlayerContainer";
import VideoReplacement from "./VideoReplacement";
import NewCidGeneration from "./NewCidGeneration";
import FileGeneration from "./FileGeneration";
import MomentTabs from "./Moments/MomentTabs";
import MovieFilterIcon from "@material-ui/icons/MovieFilter"
import { fetchSupportUsers } from "./actions/supportUserActions";
import UserManager from "./UserManager";
import PersonIcon from "@material-ui/icons/Person";
import HttpsIcon from "@material-ui/icons/Https";
import Tooltip from "@material-ui/core/Tooltip";
import PlaylistDescriptionContainer from "./PlaylistDescription/PlaylistDescriptionContainer";
import StatusContainer from "./Ingestion/IngestionStatusContainer";
import { includes } from 'lodash';
import ErrorMessage from './ErrorMessage'
import CampaignImageUpload from './CampaignImageUpload';
import AccessPortal from './Access portal/AccessPortal';
import IngestionStatsHelper from "./IngestionStatsHelper/IngestionStatsHelper";
import SyncTab from './SyncTab';
import MtnPlay from './MtnPlay';
import MicroDramaIngestion from './MicroDramaIngestion';
import MasterCategory from './MasterCategory';
import LowResGeneration from './LowResGeneration.js';
import HighResGeneration from './HighResGeneration.js';
import { CategoryRounded } from '@material-ui/icons';
const drawerWidth = 240;

ReactGA.initialize('UA-93988255-4');
ReactGA.pageview(window.location.pathname + window.location.search);

const uiConfig = {
    signInSuccessUrl: window.location.href,
    signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        fireBaseLib.auth.GoogleAuthProvider.PROVIDER_ID,

    ],
    'signInFlow': 'popup',
};

const styles = theme => ({

    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    navigationMenu: {
        textDecoration: 'none',
        color: theme.palette.text.primary
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        color: theme.palette.text.primary
    },


    container: {
        position: 'relative',
    },
    activeMenu: {

        backgroundColor: theme.palette.type === "light" ? theme.palette.grey["50"] : theme.palette.grey.A400
    }

});


//const rootUrl = "http://dirt0.blueapple.mobi:1339";
const rootUrl = bffUrl + `/privilege/email`;
const hiddenEmails = []

class MiniDrawer extends React.Component {
    state = {
        isSignedIn: false,
        userProfile: null,
        anchorEl: null,
        openSnackbar: false
    };



    constructor(props) {
        super(props);

    }

    handleChange = event => {
        this.setState({ auth: event.target.checked });
    };

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    logout = function () {
        firebaseapp.auth().signOut();

        window.location.reload();
    };

    componentDidMount() {
        sessionStorage.AUTH_MAM_CONFIG = "pending";
        sessionStorage.DOWNLOAD_SOURCE = "pending";
        // Updating the `isSignedIn` and `userProfile` local state attributes when the Firebase Auth
        // state changes.
        this.unregisterAuthObserver = firebaseapp.auth().onAuthStateChanged((user) => {
            // this.setState({ isSignedIn: !!user, userProfile: user });
            let self = this;
            console.log("entered")
            if (user) {
                if (user.email && user.email.length > 0) {
                    if (/@vuclip.com\s*$/.test(user.email)) {
                        this.setState({ isSignedIn: true, userProfile: user });

                        sessionStorage.userEmail = user.email;

                        self.props.fetchPrivileges(user.email);
                        self.props.fetchSupportUsers({ emailid: user.email });
                        self.props.fetchPrivilegesWithRegions(user.email);

                        const authInstance = axios.create({
                            baseURL: `${rootUrl}?emailId=` + user.email,
                            timeout: 120000,
                            headers: { 'ACCEPT': 'application/vnd.vuclip.cms.v2+json;charset=UTF-8' }
                        });


                        self.setState({
                            errorMessages: {}
                        });

                        authInstance.get()
                            .then(function (response) {
                                if (response.data) {
                                    if (response.data.status === "SUCCESS") {
                                        if (response.data.entity) {

                                            let authResponse = response.data.entity;
                                            sessionStorage.userName = authResponse.login;

                                            let privileges = authResponse.privileges;

                                            let mamFlag = false;
                                            let downloadSourceFlag = false;
                                            let ingestionToolFlag = false;

                                            _.forEach(privileges, function (privilege) {
                                                if (privilege.code && privilege.code === "AUTH_MAM_CONFIG") {
                                                    mamFlag = true;
                                                }
                                                if (privilege.code && privilege.code === "DOWNLOAD_SOURCE") {
                                                    downloadSourceFlag = true;
                                                }
                                                // Ingestion Tool
                                                if (privilege.name && privilege.name === "Ingestion Tool") {
                                                    ingestionToolFlag = true;
                                                }
                                            });

                                            if (mamFlag === true) {
                                                sessionStorage.AUTH_MAM_CONFIG = true;
                                            } else {
                                                sessionStorage.AUTH_MAM_CONFIG = false;
                                            }

                                            if (downloadSourceFlag === true) {
                                                sessionStorage.DOWNLOAD_SOURCE = true;
                                            } else {
                                                sessionStorage.DOWNLOAD_SOURCE = false;
                                            }

                                            if (ingestionToolFlag === true) {
                                                sessionStorage.INGESTION_TOOL = true;
                                            } else {
                                                sessionStorage.INGESTION_TOOL = false;
                                            }

                                        } else {
                                            if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                                self.setState({
                                                    errorMessages: response.data.genericMessages
                                                });
                                            }
                                        }
                                    } else {

                                    }
                                } else {

                                    self.setState({});
                                }

                            }, function () {

                            })
                            .catch(function (error) {

                            });


                    } else {
                        this.setState({ isSignedIn: false }, function () {
                            self.handleClickSnackbar();
                        });

                    }
                } else {
                    this.setState({ isSignedIn: false, userProfile: null });
                    firebaseapp.auth().signOut();

                }
            } else {
                this.setState({ isSignedIn: false, userProfile: null });

            }

        });


        let ui = new firebaseui.auth.AuthUI(firebaseapp.auth());

        ui.start('#firebaseui-auth-container', uiConfig);
    }

    componentWillUnmount() {
        // Un-registers the auth state observer.
        this.unregisterAuthObserver();
    }

    handleClickSnackbar() {
        this.setState({ openSnackbar: true });
    };

    handleCloseSnackbar = () => {
        this.setState({ openSnackbar: false });
    };

    render() {


        const { classes, theme } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        const flex = { flexGrow: 1 };
        const vertical = 'top';
        const horizontal = 'center';


        const centredIMenuIcons = {
            marginLeft: theme.spacing(1)
        };



        const drawerTabItems = [
            {
                title: 'Viu CMS - Video Player',
                menuTitle: 'Video Player',
                tabId: 'T1',
                show: true,
                path: '/',
                icon: PlayCircleFilled,
                component: Container,

            },
            {
                title: 'Find in Programming',
                menuTitle: 'Find in Programming',
                tabId: 'T2',
                show: true,
                path: '/find-programming',
                icon: FindInPageIcon,
                component: FindProgrammingContainer
            },
            {
                title: 'Content Configurations',
                menuTitle: 'Content Configs',
                tabId: 'T3',
                show: true,
                path: '/config',
                icon: SettingIcon,
                component: ConfigContainer
            },
            {
                title: 'Playlist Descriptions',
                menuTitle: 'Playlist Descriptions Upload',
                tabId: 'T4',
                show: true,
                path: '/playlist-description',
                icon: FeaturedPlayListIcon,
                component: PlaylistDescriptionContainer
            },
            {
                title: 'Thumbnail Checker Tool',
                menuTitle: 'Thumbnail Checker',
                tabId: 'T5',
                show: true,
                path: '/thumbnail-checker',
                icon: ImageIcon,
                component: ThumbnailPrint
            },
            {
                title: 'Transcoding Status Checker',
                menuTitle: 'Transcoding Checker',
                tabId: 'T6',
                show: true,
                path: '/transcoding-status',
                icon: AssessmentIcon,
                component: TranscodingStatusContainer
            },
            {
                title: 'Ingestion Helper Tools',
                menuTitle: 'Ingestion Helper',
                tabId: 'T7',
                show: true,
                path: '/ingestion-helper',
                icon: InputIcon,
                component: IngestionHelperContainer
            },
            {
                title: 'Transcoding Helper',
                menuTitle: 'Transcoding Helper',
                tabId: 'T8',
                show: true,
                path: '/transcoding-helper',
                icon: InputIcon,
                component: TranscodingHelperContainer
            },
            {
                title: 'Transcoding Trigger Tool',
                menuTitle: 'Transcoding Trigger',
                tabId: 'T9',
                show: true,
                path: '/transcoding-trigger',
                icon: AssessmentIcon,
                component: TranscodingTriggerTool
            },
            {
                title: 'Simulcast Helper Tool',
                menuTitle: 'Simulcast Helper',
                tabId: 'T10',
                show: true,
                path: '/simulcast-helper',
                icon: AssignmentIcon,
                component: SimulcastHelperContainer
            },
            {
                title: 'Moments Tool',
                menuTitle: 'Moments Tool',
                tabId: 'T11',
                show: true,
                path: '/moments',
                icon: MovieFilterIcon,
                component: MomentTabs
            },
            {
                title: 'User Manager',
                menuTitle: 'User Manager',
                tabId: 'T12',
                show: true,
                path: '/user-manager',
                icon: PersonIcon,
                component: UserManager
            },
            {
                title: 'Content analyzer',
                menuTitle: 'content analyzer',
                tabId: 'T13',
                show: true,
                path: '/content-analyzer',
                icon: PersonIcon,
                component: VideoAnalyzerContainer
            },
            {
                title: 'Discovery Ingestion Status',
                menuTitle: 'Discovery Ingestion Status',
                tabId: 'T14',
                show: true,
                path: '/ingestion-status',
                icon: InputIcon,
                component: StatusContainer
            },
            {
                title: 'DRM Player',
                menuTitle: 'DRM Player',
                tabId: 'T15',
                show: true,
                path: '/drm-player',
                icon: HttpsIcon,
                component: DRMPlayerContainer
            },
            {
                title: 'Source Video Replacement',
                menuTitle: 'SOURCE VIDEO REPLACEMENT',
                tabId: 'T16',
                 show: true,
                 path: '/video-replacement',
                 icon: WebAssetIcon,
                 component: VideoReplacement
             },
            {
               title: 'New Cid Generation',
                menuTitle: 'NEW CID GENERATION',
                tabId: 'T17',
                show: true,
               path: '/new-cidgeneration',
                icon: CollectionsIcon,
                component: NewCidGeneration
            },
            {
                title: 'Low/High Resolution File Generation',
                menuTitle: 'LOW/HIGH RESOLUTION FILE GENERATION',
                tabId: 'T18',
                show: true,
                path: '/file-generation',
                icon: AssignmentTurnedInIcon,
                component: FileGeneration
            },
            {
                title: 'Campaign Image Upload',
                menuTitle: 'CAMPAIGN IMAGE UPLOAD',
                tabId: 'T19',
                show: true,
                path: '/campaign-image-upload',
                icon: ImageIcon,
                component: CampaignImageUpload
            },
            {
                title: 'Access portal',
                menuTitle: 'ACCESS PORTAL',
                tabId: 'T20',
                show: true,
                path: '/access-portal',
                icon: ImageIcon,
                component: AccessPortal
            },
            {
                title: 'Ingestion Helper Stats',
                menuTitle: 'INGESTION STATS HELPER',
                tabId: 'T21',
                show: true,
                path: '/ingestion-stats-helper',
                icon: AssessmentIcon,
                component: IngestionStatsHelper
            },
            {
                title: 'Sync Tab',
                menuTitle: 'SYNC TAB',
                tabId: 'T22',
                show: true,
                path: '/sync-tab',
                icon: AssignmentIcon,
                component: SyncTab
            },
            {
                title: 'MTN Play',
                menuTitle: 'MTN PLAY',
                tabId: 'T23',
                show: true,
                path: '/mtn-play',
                icon: MovieFilterIcon,
                component: MtnPlay
            },
            {
                title: 'Master Category',
                menuTitle: 'MASTER CATEGORY',
                tabId: 'T25',
                show: true,
                path: '/master-category',
                icon: CategoryRounded,
                component: MasterCategory
            },
            {
                title: 'LowResGeneration',
                menuTitle: 'LowResGeneration',
                tabId: 'T24',
                show: true,
                path: '/LowResGeneration',
                icon: WebAssetIcon,
                component: LowResGeneration
           },
           {
            title: 'HighResGeneration',
            menuTitle: 'HighResGeneration',
            tabId: 'T26',
            show: true,
            path: '/HighResGeneration',
            icon: WebAssetIcon,
            component: HighResGeneration
       } ,
            {
                title: 'MicroDrama Ingestion',
                menuTitle: 'MicroDrama Ingestion',
                tabId: 'T27',
                show: true,
                path: '/microdrama-ingestion',
                icon: CollectionsIcon,
                component: MicroDramaIngestion
            }
        ];
        const { tabsallowed } = this.props.supportUsers.length > 0 ? this.props.supportUsers[0] : { tabsallowed: '' }
        return (
            <div className={classes.root}>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={this.state.openSnackbar}
                    onClose={this.handleCloseSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<Typography variant={'subtitle1'} id="message-id">Please use Vuclip Google
                        account.</Typography>}
                />
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: this.state.open,
                    })}
                >

                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, {
                                [classes.hide]: this.state.open,
                            })}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" style={flex} noWrap>



                            {


                                drawerTabItems.map((tabItem, index) => {
                                    return (tabsallowed.includes(tabItem.tabId)) ? <Route exact path={tabItem.path} key={index}
                                        render={() => <span> {tabItem.title} </span>}></Route> : null
                                })}

                        </Typography>

                        <div className={classes.divider} />

                        <div style={{padding:"0 26px"}}>
                            <a href='https://sites.google.com/vuclip.com/cmstoolhandbook/home' target="_blank" style={{color:"white", fontSize:"16px"}}>
                            ReadMe
                            </a>
                        </div>

                        {this.state.userProfile &&
                            <Typography variant="subtitle1" color="inherit" noWrap>
                                {this.state.userProfile.displayName}

                            </Typography>}

                        {this.state.isSignedIn === true &&
                            <span>
                                <IconButton
                                    aria-owns={open ? 'menu-appbar' : null}
                                    aria-haspopup="true"
                                    onClick={this.handleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>

                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={open}
                                    onClose={this.handleClose}
                                >

                                    <MenuItem onClick={this.props.toggleDarkTheme}>Toggle Dark Mode</MenuItem>
                                    <MenuItem onClick={this.logout.bind(this)}>Sign Out</MenuItem>
                                </Menu>
                            </span>}


                    </Toolbar>
                </AppBar>

                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: this.state.open,
                        [classes.drawerClose]: !this.state.open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open,
                        }),
                    }}
                    open={this.state.open}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={this.handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>
                    <Divider />

                    {
                        drawerTabItems.map((tabItem, index) => {
                            return (true) ? <Route exact path={tabItem.path} key={index} render={() =>

                                <div>
                                    {drawerTabItems.map((tabItemElement, index) => {


                                        return (tabsallowed.includes(tabItemElement.tabId) && tabItemElement.show === true) ? <React.Fragment key={index}>
                                            <List
                                                className={this.props.location.pathname === tabItemElement.path ? classes.activeMenu : ''}>
                                                <div>
                                                    <Tooltip title={tabItemElement.menuTitle}>

                                                        <Link to={tabItemElement.path} className={classes.navigationMenu}>
                                                            <ListItem button>
                                                                <ListItemIcon style={centredIMenuIcons}>
                                                                    <tabItemElement.icon />
                                                                </ListItemIcon>
                                                                <ListItemText primary={tabItemElement.menuTitle} />
                                                            </ListItem>
                                                        </Link>
                                                    </Tooltip>
                                                </div>
                                            </List>
                                            <Divider />
                                        </React.Fragment> : null

                                    })}
                                </div>
                            }>

                            </Route> : null
                        })

                    }

                    <VersionInfo />

                </Drawer>


                <main className={classes.content}>

                    <div className={classes.toolbar} />
                    {this.state.isSignedIn === false && (!this.state.userProfile) &&
                        <Typography variant='subtitle1' align="center">Please use Vuclip Google account to Sign
                            In</Typography>}
                    {this.state.isSignedIn === false &&
                        <div id="firebaseui-auth-container"></div>}


                    <div>
                        {this.state.isSignedIn === true &&
                            <Switch>
                                {tabsallowed.includes("T1") ? <Route path="/" exact component={Container} /> : null}
                                {drawerTabItems.slice(1).map((tabItem, i) => (
                                    tabsallowed.includes(tabItem.tabId) ?
                                        <Route key={i} path={tabItem.path} component={tabItem.component} /> : null
                                ))
                                }
                                {!this.props.loading ?
                                    <Route path="*" component={ErrorMessage}></Route>
                                    : null}
                            </Switch>
                        }

                    </div>

                </main>
            </div>
        );
    }
}

MiniDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        supportUsers: state.supportUser.supportUsers, loading: state.supportUser.loading
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPrivileges: (emailId) => dispatch(fetchPrivileges(emailId)),
        fetchPrivilegesWithRegions: (emailId) => dispatch(fetchPrivilegesWithRegions(emailId)),
        fetchSupportUsers: (data) => dispatch(fetchSupportUsers(data))
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)((withStyles(styles, { withTheme: true })(MiniDrawer))));